import {
  AndroidOutlined,
  AppleOutlined,
  SafetyCertificateOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import VehicleEdit from './VehicleEdit';
import TabDrivers from './TabDrivers';
import { useLocation, useParams, Location } from 'react-router';
import { Tabs } from 'antd';
import { useVehicleCompanyData } from '../../../../../../../Hooks/TT_ELD/Vehicles';
import VehicleIftaReport from './VehicleIftaReport';
import useRouteQuery from '../../../../../../../Utils/useRouterQuery';
import TruckCamera from './TruckCamera';

type MyObjectType = {
  [key: string | number]: any;
};
interface Params {
  id: string | undefined;

  [key: string]: string | undefined;
}

const VehicleTabs = ({ vehicleId }: { vehicleId: string | number }) => {
  const { id } = useParams<Params>();
  const [tabKey, setTabKey] = useRouteQuery('1', 'tabKey', (v) => String(v));
  const location: Location = useLocation();
  let vehicles = location.pathname === `/vehicles/vehicles/${id}`;

  const { data, isLoading, isFetching }: MyObjectType = useVehicleCompanyData(
    vehicles ? id : vehicleId,
  );

  const items = [
    {
      label: <span>MAIN FIELDS</span>,
      key: '1',
      children: <VehicleEdit vehicleId={vehicles ? id : vehicleId} />,
      icon: <AppleOutlined rev={undefined} />,
    },
    {
      label: <span>Vehicle Driver</span>,
      key: '2',
      children: (
        <TabDrivers
          driver={data?.driver}
          codriver={data?.codriver}
          isLoading={isLoading}
          isFetching={isFetching}
        />
      ),
      icon: <AndroidOutlined rev={undefined} />,
    },
    {
      label: <span>Truck Camera</span>,
      key: '3',
      children: <TruckCamera vehicleId={vehicles ? id : vehicleId} />,
      icon: <VideoCameraOutlined rev={undefined} />,
    },
    // {
    //   label: <span>IFTA Report</span>,
    //   key: '3',
    //   children: <VehicleIftaReport companyId={data?.companyId} />,
    //   icon: <SafetyCertificateOutlined rev={undefined} />,
    // },
  ];

  return (
    <>
      <div style={{ padding: '12px 8px' }}>
        <Tabs
          onTabClick={(e) => {
            setTabKey(e);
          }}
          defaultActiveKey={tabKey || '1'}
          style={{ height: '100%' }}
          items={items.map((tab) => {
            return {
              label: tab.label,
              key: tab.key,
              children: tab.children,
              icon: tab.icon,
            };
          })}
        />
      </div>
    </>
  );
};

export default VehicleTabs;
